import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/ui.css';
import './styles/pages.css';
import './i18n';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
/**
 * StrictMode 비활성: React 19 개발 모드의 이중 마운트/해제가 @hello-pangea/dnd 등
 * DOM을 직접 다루는 라이브러리와 맞물리면 간헐적으로
 * "removeChild: The node to be removed is not a child of this node" 가 발생합니다.
 * (프로덕션 빌드에서는 StrictMode 이펙트가 없어 상대적으로 드묾)
 */
root.render(
	<Suspense fallback={
		<div style={{
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			minHeight: '100vh',
			backgroundColor: '#ffffff'
		}}>
			<div style={{
				fontSize: '14px',
				color: '#666666'
			}}>
				Loading...
			</div>
		</div>
	}>
		<App />
	</Suspense>
);

reportWebVitals();
